import { cn } from '#src/styling/cn.ts';
import { Avatar as Primitive } from 'radix-ui';
import type { ComponentProps } from 'react';

export const Avatar = ({ className, ...props }: ComponentProps<typeof Primitive.Root>) => (
  <Primitive.Root
    data-slot="avatar"
    className={cn('relative flex size-10 shrink-0 overflow-hidden rounded-full', className)}
    {...props}
  />
);

export const AvatarImage = ({ className, ...props }: ComponentProps<typeof Primitive.Image>) => (
  <Primitive.Image
    data-slot="avatar-image"
    className={cn('aspect-square h-full w-full', className)}
    {...props}
  />
);

export interface AvatarFallbackProps extends ComponentProps<typeof Primitive.Fallback> {
  name?: string;
}

export const AvatarFallback = ({ className, name, children, ...props }: AvatarFallbackProps) => (
  <Primitive.Fallback
    data-slot="avatar-fallback"
    className={cn(
      'bg-muted flex h-full w-full items-center justify-center rounded-full',
      className,
    )}
    {...props}
  >
    {children || (name ? getInitials(name) : null)}
  </Primitive.Fallback>
);

export function getInitials(name: string) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '';
  if (parts.length === 1) {
    const single = parts[0];
    return single ? single.substring(0, 2).toUpperCase() : '';
  }
  // Currently takes first and last:
  const first = parts[0];
  const last = parts[parts.length - 1];

  if (!first || !last) return '';

  const firstInitial = first.charAt(0);
  const lastInitial = last.charAt(0);

  return (firstInitial + lastInitial).toUpperCase();
}
